import Main from "../Main";
import addGlobalListener from "./utils/add-global-listener";
import addLocalListener from "./utils/add-local-listener";

/**
 * Add listeners according the trigger `events` array
 * @this {MainClassProps}
 */
Main.prototype.addListeners = function () {
  for (const trigger of this.store.values()) {
    /** Don't add listeners for initial triggers */
    if (trigger.get("initial")) {
      continue;
    }

    /** Array of events associated with a current trigger */
    const events = /** @type {EventArrayProps} */ (trigger.get("events"));

    /** Check if the trigger has a "target" parameter */
    const targetParameter = /** @type {Map<String, any>} */ (
      /** @type {unknown} */ (trigger.get("p_target"))
    );

    const targetValue = /** @type {Array<TorusElement> | null} */ (
      targetParameter?.get("value")
    );

    const targets = /** @type {Array<TorusElement>} */ (
      targetValue ? targetValue : [this.element]
    );

    const details = /** @type {ListenerDetailsProps} */ (new Map());

    details.set("trigger", trigger);
    details.set("main", this);

    for (const event of events) {
      /** Global (window) event */
      if (["scroll", "pointermove", "touchmove"].includes(event)) {
        addGlobalListener(this, event, details);
      } else {
        addLocalListener(this, event, details, trigger, targets);
      }
    }
  }
};

export default Main.prototype.addListeners;
